import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { AccountContextService } from '../modules/shared/services/account-context.service';
import { ModalsService } from '../modules/shared/services/modals.service';

@Component({
  selector: 'app-auth-callback',
  template: ``,
  styleUrls: [],
  standalone: false
})
export class AuthCallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private selectionService = inject(AccountContextService);
  private router = inject(Router);
  private modals = inject(ModalsService);

  async ngOnInit() {
    const callbackResponse = await this.authService.handleRedirectCallback();

    if (callbackResponse.error) {
      const isLogout = await this.modals.Confirm(
        `${callbackResponse.error.error}${callbackResponse.error.error_description ? `:${callbackResponse.error.error_description}` : ''}`,
        'Failed to login', 'Logout', 'primary', 'Close');
      if (isLogout) {
        await this.authService.logout();
      } else {
        this.router.navigateByUrl('/');
      }
      return;
    }

    // init authenticated user
    await this.authService.getIsAuthenticated(true);
    await this.selectionService.waitForInit();

    let targetRoute = callbackResponse.target;

    const emptyRoute = targetRoute === '' || targetRoute === '/';
    const isSysAdmin = await this.authService.isSysAdmin();
    const hasAccount = !!this.selectionService.accountId;

    if (emptyRoute || (!emptyRoute && isSysAdmin && !hasAccount)) {
      targetRoute = await this.authService.userDefaultRoute();
    }
    if (!hasAccount) {
      await this.selectionService.setDefaultContext();
    }
    this.router.navigateByUrl(targetRoute);
  }
}
